module.exports = __webpack_public_path__ + "static/img/newimg6.5d65e72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg6.png
// module id = x6RU
// module chunks = 1